// extracted by mini-css-extract-plugin
export default {"interviews":"Interviews-module__interviews__5pWka","content":"Interviews-module__content__FMC1I"};